import React from 'react';
import { Helmet } from 'react-helmet-async';

export const SITE_URL = 'https://inspectiq.in';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

/**
 * Reusable SEO component — sets per-page title, description, canonical,
 * Open Graph / Twitter tags and optional JSON-LD structured data.
 */
const Seo = ({
  title,
  description,
  path = '/',
  image = DEFAULT_IMAGE,
  type = 'website',
  noindex = false,
  structuredData,
}) => {
  const url = `${SITE_URL}${path === '/' ? '' : path}`;
  const fullTitle = title
    ? `${title} | InspectIQ`
    : 'InspectIQ | Independent Marine & Cargo Inspection Services Worldwide';

  const schemas = Array.isArray(structuredData)
    ? structuredData
    : structuredData
    ? [structuredData]
    : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="InspectIQ Private Limited" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />

      {schemas.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default Seo;
